<template>
  <div ref="chartdiv" class="hello">
  </div>
</template>

<script>
import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';
import am5themesAnimated from '@amcharts/amcharts5/themes/Animated';

am5.addLicense('AM5C315878972');


export default {
  name: 'MixedChart',
  props: {
    data: {
      type: Array,
      default: () => [{
        "85th_PercentileSpeed": 49,
        Annual_Average_Daily_Traffic: 2287,
        Average_Speed: 42.5,
        Site: "90003761",
        Year: "2018",
        average_length: 3.3,
        latitude: 50.96239,
        longitude: - 3.0919,
        name: "000090003761 - B3170 Corfe (Programme Site C)",
        "speed limit": 60,
        total: 54891,
        type: "dmp22",
        usmart_id: "90003761dmp22_2018"
      }, {
        "85th_PercentileSpeed": 49,
        Annual_Average_Daily_Traffic: 2895,
        Average_Speed: 41.5,
        Site: "90003761",
        Year: "2019",
        average_length: 3.8,
        latitude: 50.96249,
        longitude: -3.0919,
        name: "000090003761 - B3170 Corfe (Programme Site C)",
        "speed limit": 60,
        total: 86860,
        type: "dmp22",
        usmart_id: "90003761dmp22_2019"
      }],
    }
  },

  watch: {
    data(n) {
      const sortedData = [...n].sort((a, b) => Number(a.Year) - Number(b.Year));
      if (n.length > 0) {
        this.xAxis.data.setAll(sortedData);
        this.series1.data.setAll(sortedData);
        this.series2.data.setAll(sortedData);
        this.series3.data.setAll(sortedData);
        this.legend.data.setAll(this.chart.series.values);
      } else {
        this.xAxis.data.setAll(sortedData);
        this.series1.data.setAll(sortedData);
        this.series2.data.setAll(sortedData);
        this.series3.data.setAll(sortedData);
        this.legend.data.setAll(this.chart.series.values);
      }
    }
  },
  mounted() {
    const root = am5.Root.new(this.$refs.chartdiv);
    // Sort data by Year ascending
    const sortedData = [...this.data].sort((a, b) => Number(a.Year) - Number(b.Year));
    root.setThemes([am5themesAnimated.new(root)]);

    // Set themes
    // https://www.amcharts.com/docs/v5/concepts/themes/
    root.setThemes([
      am5themesAnimated.new(root)
    ]);

    // Create chart
    // https://www.amcharts.com/docs/v5/charts/xy-chart/
    const chart = root.container.children.push(am5xy.XYChart.new(root, {
      panX: false,
      panY: false,
      wheelY: "none",
      layout: root.verticalLayout
    }));
    this.chart = chart;

    // create axis
    const xAxis = chart.xAxes.push(am5xy.CategoryAxis.new(root, {
      categoryField: "Year",
      renderer: am5xy.AxisRendererX.new(root, { minGridDistance: 50 }),
      tooltip: am5.Tooltip.new(root, {})
    }));
    this.xAxis = xAxis;

    // 1st y axis
    const yRenderer = am5xy.AxisRendererY.new(root, {
      opposite: false
    });
    const yAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        maxDeviation: 1,
        min: 0,             // ⬅️ Force the axis to start at 0
        strictMinMax: true,
        renderer: yRenderer
      })
    );

    // 2nd y axis
    const OppYRenderer = am5xy.AxisRendererY.new(root, {
      opposite: true
    });
    yRenderer.grid.template.set("forceHidden", true);
    OppYRenderer.grid.template.set("forceHidden", true);
    const oppositeYAxis = chart.yAxes.push(
      am5xy.ValueAxis.new(root, {
        maxDeviation: 1,
        min: 0,             // ⬅️ Force the axis to start at 0
        strictMinMax: true,
        renderer: OppYRenderer
      })
    );
    // Add series
    // https://www.amcharts.com/docs/v5/charts/xy-chart/series/

    const series1 = chart.series.push(
      am5xy.ColumnSeries.new(root, {
        name: "Annual Average Daily Traffic",
        xAxis,
        yAxis,
        valueYField: "Annual_Average_Daily_Traffic",
        categoryXField: "Year",
        tooltip: am5.Tooltip.new(root, {
          pointerOrientation: "horizontal",
          labelText: "Average Daily Traffic in {categoryX}: {valueY} {info}"
        })
      })
    );

    series1.columns.template.setAll({
      tooltipY: am5.percent(10),
    });

    series1.data.setAll(sortedData);
    this.series1 = series1;

    const series2 = chart.series.push(
      am5xy.LineSeries.new(root, {
        name: "Average (Mean) Speed",
        xAxis,
        yAxis: oppositeYAxis,
        valueYField: "Average_Speed",
        categoryXField: "Year",
        tooltip: am5.Tooltip.new(root, {
          pointerOrientation: "horizontal",
          labelText: "Average Speed in {categoryX}: {valueY} {info}"
        })
      })
    );

    series2.data.setAll(sortedData);

    series2.bullets.push(() => {
      return am5.Bullet.new(root, {
        sprite: am5.Circle.new(root, {
          strokeWidth: 3,
          stroke: series2.get("stroke"),
          radius: 5,
          fill: root.interfaceColors.get("background")
        })
      });
    });
    this.series2 = series2;

    const series3 = chart.series.push(
      am5xy.LineSeries.new(root, {
        name: "85th Percentile Speed",
        xAxis,
        yAxis: oppositeYAxis,
        valueYField: "85th_PercentileSpeed",
        categoryXField: "Year",
        tooltip: am5.Tooltip.new(root, {
          pointerOrientation: "horizontal",
          labelText: "85th Percentile Speed in {categoryX}: {valueY} {info}"
        })
      })
    );
    series3.set("fill", am5.Color.fromString('ffc56f'));
    series3.set("stroke", am5.Color.fromString('ffc56f'));
    series3.data.setAll(sortedData);
    series3.bullets.push(() => {
      return am5.Bullet.new(root, {
        sprite: am5.Circle.new(root, {
          strokeWidth: 3,
          stroke: am5.Color.fromString('ffc56f'),
          radius: 5,
          fill: root.interfaceColors.get("background")
        })
      });
    });

    this.series3 = series3;

    chart.set("cursor", am5xy.XYCursor.new(root, {}));

    // Add legend
    // https://www.amcharts.com/docs/v5/charts/xy-chart/legend-xy-series/
    const legend = chart.children.push(
      am5.Legend.new(root, {
        centerX: am5.p50,
        x: am5.p50
      })
    );
    legend.data.setAll(chart.series.values);

    this.legend = legend;

    // createAxisAndSeries(false, 'distance');
    // createAxisAndSeries(true, 'duration');
    xAxis.data.setAll(sortedData);
    this.root = root;
  },

  beforeDestroy() {
    if (this.root) {
      this.root.dispose();
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hello {
  width: 35rem;
  height: 20rem;
}
</style>
